<template>
    <div class="container-fluid">
        <div class="d-flex align-items-center">
            <h2 class="page-heading mr-auto">Создание новости</h2>
            <btn-action class="btn btn-primary" @click="createNews()">Создать</btn-action>
            <btn-action class="btn btn-primary" @click="createAndSendNews()">Создать и разослать всем</btn-action>
        </div>
        <div class="row">
            <div class="col-lg col-sm">
                <div class="card mb-4">
                    <h3 class="card-header">Заголовок</h3>
                    <div class="card-body">
        <input-form-custom
          name="header"
          v-model="header"
          label="Часовой пояс"
          class="mb-3"
          inputClass="form-control"
        />
                    </div>
                </div>
                <div class="card mb-4">
                    <h3 class="card-header">Содержимое</h3>
                    <div class="card-body">
    <vue-editor v-model="content"></vue-editor>
                    </div>
                </div>
                <div class="card mb-4">
                    <div class="card-body">
                        <btn-action class="btn btn-primary mb-2" @click="sendNews()">Сохранить новость</btn-action>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    metaInfo: {title: 'Создание новости'},
    data () {
        return {
            selectedRegion: null,
            oldSelectedRegion: null,
            regionsList: [],
            content: "",
            header: ""
        }
    },
    methods: {
        sendNews () {
            api.post(`billing/news/addnews`, {'header': this.header, 'body': this.content})
            .then(data => {
                this.$router.push('/billing/news/news-list/')
            })
        },
        createNews()
        {

        },
        createAndSendNews()
        {

        }
    },
    watch: {
    },
    filters: {
    },
    mounted: function () {
    },
    asyncComputed: {
    },
}
</script>


<style lang="scss" scoped>
    .search-block {
        height: 60vh;
    }
    svg{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);
    max-width:128px;
    max-height:128px;
    }
    .magnify{
    fill:#00a0e3;
    animation:search 1s infinite ease;
    }
    .doc{
    fill:#00a0e3;
    animation:flyby 1s infinite ease;
    }


    @keyframes search {
    0%{
        transform:translate(40px, 40px) scale(.6);
    }
    50%{
        transform:translate(20px, 20px) scale(.6);
    }
    100%{
        transform:translate(40px, 40px) scale(.6);
    }
    }

    @keyframes flyby {
    0%{
        transform:translate(-20px, 20px) scale(.2);
        opacity:0
    }
    50%{
        transform:translate(30px, 20px) scale(.5);
        opacity:1
    }
    100%{
        transform:translate(100px, 20px) scale(.2);
        opacity:0
    }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/news/create-news.vue